import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import NotFound from "./pages/NotFound.tsx";
import Admin from "./pages/Admin.tsx";
import Unsubscribe from "./pages/Unsubscribe.tsx";
import VerifyAdminPassword from "./pages/VerifyAdminPassword.tsx";
import GuideArticle from "./pages/GuideArticle.tsx";
import Guide from "./pages/Guide.tsx";
import BlogArticle from "./pages/BlogArticle.tsx";
import MarocSurfing from "./pages/MarocSurfing.tsx";
import Tarifs from "./pages/Tarifs.tsx";
import { useDynamicFavicon } from "@/hooks/useDynamicFavicon";
import AdminErrorBoundary from "@/components/admin/AdminErrorBoundary";
import GoogleAdsTag from "@/components/GoogleAdsTag";

const queryClient = new QueryClient();

const App = () => {
  useDynamicFavicon();
  return (
  <QueryClientProvider client={queryClient}>
    <GoogleAdsTag />
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/home" element={<Index />} />
          {["/services", "/flotte", "/activites", "/excursion", "/reservation"].map((p) => (
            <Route key={p} path={p} element={<Index />} />
          ))}
          <Route path="/admin" element={<AdminErrorBoundary><Admin /></AdminErrorBoundary>} />
          <Route path="/Adminup" element={<AdminErrorBoundary><Admin /></AdminErrorBoundary>} />
          <Route path="/adminup" element={<AdminErrorBoundary><Admin /></AdminErrorBoundary>} />
          <Route path="/verify-admin-password" element={<VerifyAdminPassword />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/guide/blog/:slug" element={<BlogArticle />} />
          <Route path="/guide/:slug" element={<GuideArticle />} />
          <Route path="/maroc-surfing" element={<MarocSurfing />} />
          <Route path="/surfing" element={<MarocSurfing />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  );
};

export default App;
